import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-6xl" }, "Thank You", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 py-8 text-3xl max-w-3xl" }, "By taking this survey you have contributed to the design of a new accessible font!", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  class: "font-bold text-3xl mt-10 text-black hover:text-black underline cursor-pointer",
  href: "/"
}, "Back to survey homepage", -1)

import Logo from './Logo.vue';
import Divider from './Divider.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ThankYou',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(Logo),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Divider)
      ]),
      _hoisted_2,
      _hoisted_3,
      _hoisted_4
    ])
  ]))
}
}

})